var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-alert',{attrs:{"variant":_vm.dismissibleType,"dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]),_vm._v(" "),_c('div',[_vm._t("default")],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.boolLoading,"label":_vm.txtLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BasePageComponent.vue?vue&type=template&id=214fcec4&
// module id = null
// module chunks = 